export default __webpack_public_path__ + "static/1246-b1f4fdedc75935619d7112a3c19c70e3.gif";